const BaseAnnotationTool = cornerstoneTools.importInternal('base/BaseAnnotationTool');
const external = cornerstoneTools.external;
const draw = cornerstoneTools.importInternal('drawing/draw');
const drawLine = cornerstoneTools.importInternal('drawing/drawLine');
const getNewContext = cornerstoneTools.importInternal('drawing/getNewContext');
const lengthCursor = cornerstoneTools.importInternal('cursors/lengthCursor');
const throttle = cornerstoneTools.importInternal('util/throttle');

// State
const addToolState = cornerstoneTools.addToolState;
const removeToolState = cornerstoneTools.removeToolState;
const getToolState = cornerstoneTools.getToolState;

const toolStyle = cornerstoneTools.toolStyle;
const toolColors = cornerstoneTools.toolColors;

const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const lineSegDistance = cornerstoneTools.importInternal('util/lineSegDistance');
const getPixelSpacing = cornerstoneTools.importInternal('util/getPixelSpacing');

/**
 * @public
 * @class VLineTool
 * @memberof Tools.Annotation
 * @classdesc Tool for create vertical lines.
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class VLineTool extends BaseAnnotationTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'VLine',
      supportedInteractionTypes: ['Mouse', 'Touch'],
      svgCursor: lengthCursor,
      configuration: {
        renderDashed: false,
      },
    };

    super(props, defaultProps);

    // this.mouseDragCallback = this._preventMouseOut.bind(this);
    // this.mouseDragCallback = this._preventMouseOut;

    this.throttledUpdateCachedStats = throttle(this.updateCachedStats, 110);
  }

  createNewMeasurement(eventData) {
    const goodEventData =
      eventData && eventData.currentPoints && eventData.currentPoints.image;

    if (!goodEventData) {
      logger.error(
        `required eventData not supplied to tool ${this.name}'s createNewMeasurement`
      );

      return;
    }

    return {
      visible: true,
      active: true,
      color: undefined,
      invalidated: true,
      handles: {
        end: {
          x: eventData.currentPoints.image.x,
          y: eventData.image.rows / 2,
          highlight: true,
          active: true,
        },
      },
    };
  }

  /**
   *
   *
   * @param {*} element
   * @param {*} data
   * @param {*} coords
   * @returns {Boolean}
   */
  pointNearTool(element, data, coords) {
    const hasEndHandle = data && data.handles && data.handles.end;
    const validParameters = hasEndHandle;


    if (!validParameters) {
      logger.warn(
        `invalid parameters supplied to tool ${this.name}'s pointNearTool`
      );

      return false;
    }

    if (data.visible === false) {
      return false;
    }

    return (
      lineSegDistance(element, { x: data.handles.end.x, y: 0 }, { x: data.handles.end.x, y: data.handles.end.y * 2 }, coords) <
      20
    );
  }

  updateCachedStats(image, element, data) {
    data.invalidated = false;
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    const renderDashed = this.configuration.renderDashed;
    const toolData = getToolState(evt.currentTarget, this.name);

    if (!toolData) {
      return;
    }

    // We have tool data for this element - iterate over each one and draw it
    const context = getNewContext(eventData.canvasContext.canvas);
    const { image, element } = eventData;
    const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

    const lineWidth = toolStyle.getToolWidth();
    const lineDash = cornerstoneTools.getModule('globalConfiguration').configuration.lineDash;

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];

      if (data.visible === false) {
        continue;
      }

      data.handles.end.x = Math.max(Math.min(data.handles.end.x, image.width), 0);
      data.handles.end.y = image.rows / 2;

      draw(context, context => {
        // Configurable shadow
        setShadow(context, this.configuration);

        const color = toolColors.getColorIfActive(data);

        const lineOptions = { color };

        if (renderDashed) {
          lineOptions.lineDash = lineDash;
        }

        // Draw the measurement line
        drawLine(
          context,
          element,
          { x: data.handles.end.x, y: 0 },
          { x: data.handles.end.x, y: image.rows },
          lineOptions
        );

      });
    }

  }

  // mouseDragCallback(evt) {
  //   const toolState = getToolState(evt.currentTarget, this.name);
  //   console.log('ENTRA');
  //   if (toolState) {
  //     const toolData = toolState.data[0];
  //     console.log('toolData', toolData);
  //     console.log('evt.detail', evt.detail);
  //     if (toolData.handles.start) {
  //       console.log('start b', toolData.handles.start.x, toolData.handles.start.y);
  //       toolData.handles.start.x = Math.max(Math.min(toolData.handles.start.x, evt.detail.image.width), 0)
  //       toolData.handles.start.y = Math.max(Math.min(toolData.handles.start.y, evt.detail.image.height), 0)
  //       console.log('start a', toolData.handles.start.x, toolData.handles.start.y);
  //     }
  //     if (toolData.handles.end) {
  //       console.log('end b', toolData.handles.end.x, toolData.handles.end.y);
  //       toolData.handles.end.x = Math.max(Math.min(toolData.handles.end.x, evt.detail.image.width), 0)
  //       toolData.handles.end.y = Math.max(Math.min(toolData.handles.end.y, evt.detail.image.height), 0)
  //       console.log('end a', toolData.handles.end.x, toolData.handles.end.y);
  //     }

  //     // this.onMeasureModified(evt, toolData);
  //   }
  // }

  // onMeasureModified(ev, toolData) {
  //   console.log('onMeasureModified');
  // }

}
